import { useQuery } from 'react-query'
import { P, Wrapper } from '@farewill/ui'

import axiosRequest from 'lib/axios/api-request'
import { formatDate } from 'lib/formatting/dates'

type AccountAttributes = {
  uuid: string
  email: string
  createdAt: string
}

const fetchAccount = async (
  accountUuid: string
): Promise<AccountAttributes | null> => {
  try {
    const { data } = await axiosRequest({
      url: `/api/accounts/admin/${accountUuid}`,
      silentStatuses: [404],
    })
    return data.data.attributes
  } catch (error) {
    const status = (error as { response?: { status?: number } }).response
      ?.status
    if (status === 404) return null
    throw error
  }
}

const AccountDetails = ({
  accountUuid,
}: {
  accountUuid: string
}): React.ReactElement => {
  const {
    data: account,
    isIdle,
    isLoading,
  } = useQuery(['account', accountUuid], () => fetchAccount(accountUuid), {
    enabled: !!accountUuid,
    retry: false,
  })

  if (!accountUuid) {
    return <P>No account registered.</P>
  }

  if (isIdle || isLoading) {
    return <P>Loading...</P>
  }

  return (
    <Wrapper>
      {account ? (
        <P>
          Account registered at <strong>{account.email}</strong> on{' '}
          {formatDate(account.createdAt)}.
        </P>
      ) : (
        <P>No account registered.</P>
      )}
    </Wrapper>
  )
}

export default AccountDetails
